import { Backdrop, CircularProgress } from '@mui/material';

const BackdropSpinner = () => (
	<Backdrop open sx={{ zIndex: 99999999 }}>
		<CircularProgress />
	</Backdrop>
);

export default BackdropSpinner;
